import { ImageLocal } from "@/components/ImageLocal";
import { useBankStore } from "@/stores/banks";
import { safeBankNumber } from "@/utils/safe";
import classNames from "classnames";
import { useMemo } from "react";
import styles from "./styles.module.scss";
import { useConfigContext } from "@/app";
type BankInfo = {
  bankId: number;
  bankName: string;
  bankNo: string;
  bankBranch: string;
  province: string;
  provinceName: string;
  city: string;
  cityName: string;
  logoImg: string;
  realName: string;
};
type BankItemProps = {
  item: BankInfo;
  index: number;
};

export const BankItem = ({ item, index }: BankItemProps) => {
  const bankStore = useBankStore();
  const bankName = useMemo(() => {
    return bankStore.bankMap && bankStore.bankMap[item.bankId]
      ? bankStore.bankMap[item.bankId]
      : item.bankId;
  }, [item.bankId, bankStore.bankMap]);
  return (
    <div className={classNames(styles.card, styles[`bg${index}`])}>
      <div className={styles.item_icon}>
        <ImageLocal src={item.logoImg} />
      </div>

      <div className={styles.item_text}>
        <span className={styles.weight}> {bankName} </span>
        <div>可转账</div>
        <span className={styles.weight}> {safeBankNumber(item.bankNo)} </span>
      </div>
    </div>
  );
};
